import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GridEventListener, GridEvents } from "@mui/x-data-grid-pro";

import { selectYear } from "../../../reducers/applicationReducer";
import {
  cleanUpCollectionPointDetail,
  getCollectionPointDetailThunk,
  setCollectionPoint,
} from "../../../reducers/collectionPointReducer";
import { getBillingBilling, getBillingId } from "../../../selectors/billing";
import { buildBillingPageUrl, buildCollectionPointUrl } from "../../../utils/url";

interface BillingLocationsTableHandlers {
  handleAdditionalRowClick: GridEventListener<GridEvents.rowClick>;
}

export const useGetBillingLocationsTableHandlers = (): BillingLocationsTableHandlers => {
  const dispatch = useDispatch();
  const history = useHistory();
  const billingId = useSelector(getBillingId);
  const billing = useSelector(getBillingBilling);

  const handleAdditionalRowClick: GridEventListener<GridEvents.rowClick> = (params) => {
    const collectionPointId = params.row.locationId;
    // Ensure the application state reflects the correct billing year before navigating to the collection point detail page
    dispatch(
      selectYear({
        value: billing.year,
        label: String(billing.year),
      })
    );
    dispatch(cleanUpCollectionPointDetail());
    dispatch(setCollectionPoint(params.row));
    dispatch(getCollectionPointDetailThunk(collectionPointId));

    history.push(
      buildCollectionPointUrl(collectionPointId, {
        prevPage: buildBillingPageUrl(billingId),
      })
    );
  };

  const billingLocationsTableHandlers: BillingLocationsTableHandlers = {
    handleAdditionalRowClick,
  };

  return billingLocationsTableHandlers;
};
